import { DummyStore } from 'src/stores';

import { TaskTable } from '../types';

export const taskStore = new DummyStore<TaskTable>(null);
